<style scoped>
    .title {
        font-size: 20px;
    }
    .col {
        height: auto;
    }
        .title2 {
        font-size: 18px;
    }
    .title3 {
        font-size: 14px;
    }
    .accent--text {
    color: #f69f00 !important;
    caret-color: #f69f00 !important;
}
</style>

<template>
  <div>
    <v-card>
      <v-subheader class="title" id="top">USTALENIA MONTAŻOWE</v-subheader>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
      <v-flex xs12 md4 class="col">
          <v-checkbox class="accent--text" label="Projekt instalacji" v-model="projekt"></v-checkbox>
      </v-flex>
      <v-flex xs12 md4 class="col">
          <v-checkbox label="Doradztwo techniczne podczas realizacji" v-model="realizacja"></v-checkbox>
      </v-flex>
      <v-flex xs12 md4 class="col">
          <v-checkbox label="Doradztwo w zakresie OSD" v-model="osd"></v-checkbox>
      </v-flex>
      </v-layout>
      <v-subheader class="title2" v-show="projekt">Projekt instalacji fotowoltaicznej</v-subheader>
      <v-subheader class="title3" v-show="projekt">A) Podstawowe dane klienta</v-subheader>
      <v-select v-show="projekt" :items="items" label="Rodzaj klienta" v-model="Item.rodzajKlienta" ></v-select>
      <v-text-field label="Imię i Nazwisko / Firma" v-model="Item.nazwa" v-show="projekt"></v-text-field>
      <v-text-field label="Ulica i numer" v-model="Item.ulica" v-show="projekt"></v-text-field>
      <v-text-field label="Miejscowość" v-model="Item.miasto" v-show="projekt"></v-text-field>
      <v-text-field label="Gmina" v-model="Item.gmina" v-show="projekt"></v-text-field>
      <v-text-field label="Kod pocztowy" v-model="Item.kod" v-show="projekt"></v-text-field>
      <v-text-field label="Telefon" type="tel" v-model="Item.telefon" v-show="projekt"></v-text-field>
      <v-text-field label="E-mail" type="email" v-model="Item.email" v-show="projekt"></v-text-field>
      
      <v-subheader class="title3" v-show="projekt">B) Jaką klient rozpatruje moc instalacji np. 4-5kW</v-subheader>
      <v-text-field label="Moc instalacji [kW]" type="number" v-model="Item.moc" v-show="projekt"></v-text-field>
      
      <v-subheader class="title3" v-show="projekt">C) Podstawowe wymiary obiektu</v-subheader>
      <v-select v-show="projekt" :items="yesno" label="Czy istnieje możliwość dołączenia projektu dachu?" v-model="Item.projektDachu" ></v-select>
      <v-select v-show="projekt" :items="rodzajdachu" label="Rodzaj dachu" v-model="Item.rodzajDachu" ></v-select>
      <v-text-field label="Długość obiektu [m]" type="number" v-model="Item.dlugosc" v-show="projekt"></v-text-field>
      <v-text-field label="Szerokość obiektu [m]" type="number" v-model="Item.szerokosc" v-show="projekt"></v-text-field>
      <v-text-field label="Długość krawędzi dachu [m]" type="number" v-model="Item.dlugoscDachu" v-show="projekt"></v-text-field>
      <v-text-field label="Kąt pochylenia dachu [°]" type="number" v-model="Item.kat" v-show="projekt"></v-text-field>
      <v-select v-show="projekt" :items="wymiarybyly" label="Wymiary zostały" v-model="Item.wymiaryByly" ></v-select>
       
      <v-subheader class="title3" v-show="projekt">D) Elektryka obiektu</v-subheader>
      <v-select v-show="projekt" :items="istniejaca" label="Instalacja istniejąca" v-model="Item.istniejaca" ></v-select>
      <v-text-field label="Przekrój przewodów w instalacji elektycznej [mm2]" type="number" v-model="Item.przekrojPrzewodu" v-show="projekt"></v-text-field>
      <v-text-field label="Wartość zabezpieczenia przedlicznikowego [A]" type="number" v-model="Item.zabezpieczenie" v-show="projekt"></v-text-field>
      <v-select v-show="projekt" :items="odgromowa" label="Instalacja odgromowa" v-model="Item.odgromowa" ></v-select>
      
      <v-subheader class="title2" v-show="realizacja">Doradztwo techniczne podczas realizacji</v-subheader>
      <v-subheader class="title3" v-show="realizacja">A)</v-subheader>
      <v-select v-show="realizacja" :items="izolacja" label="Instalacja istniejąca" v-model="Item.izolacja" ></v-select>
      <v-text-field label="Grubość izolacji [mm]" type="number" v-model="Item.gruboscIzlolacji" v-show="realizacja"></v-text-field>
      <v-text-field label="Materiał izloacji" v-model="Item.materialIzlolacji" v-show="realizacja"></v-text-field>
      <v-select v-show="realizacja" :items="materialkrokwi" label="Materiał krokwi/płatw" v-model="Item.materialKrokwi" ></v-select>
      
      <v-subheader class="title3" v-show="realizacja">B)</v-subheader>
      <v-select v-show="realizacja" :items="typdachu" label="Rodzaj dachu" v-model="Item.typDachu" ></v-select>
      <v-text-field label="Odległość między krokwiami/płatami [mm]" type="number" v-model="Item.odlegloscKrokwi" v-show="realizacja"></v-text-field>
      <v-text-field label="Grubość krokwiami/płatwi [mm]" type="number" v-model="Item.gruboscKrokwi" v-show="realizacja"></v-text-field>
      
      <v-subheader class="title2" v-show="osd">Doradztwo w zakresie OSD</v-subheader>
      <v-text-field label="Nr ewidencyjny działki" v-model="Item.nrEwidencji" v-show="osd"></v-text-field>
      <v-select v-show="osd" :items="dostawca" label="Dostawca energii elektrycznej" v-model="Item.dostawca" ></v-select>
      <v-text-field label="Nabywca energii z faktury" v-model="Item.nabywca" v-show="osd"></v-text-field>
      <v-text-field label="Wartość zabezpieczenia przedlicznikowego [A]" type="number" v-model="Item.wartoscZabezpieczenia" v-show="osd"></v-text-field> <v-text-field label="Nr PPE (Punkt Poboru Energii)" v-model="Item.ppe" v-show="osd"></v-text-field> 
      <v-text-field label="Nr licznika" v-model="Item.nrLicznika" v-show="osd"></v-text-field> 
      <v-text-field label="Moc przyłączeniowa [kW]" type="number" v-model="Item.mocPrzylaczeniowa" v-show="osd"></v-text-field>
      <v-text-field label="Moc umowna [kW]" type="number" v-model="Item.mocUmowna" v-show="osd"></v-text-field>

        
      <v-btn @click="addItem()">Wyślij</v-btn>
      
      </v-container>
    </v-card>
    <div class="overlay" v-if="!ready">
      <div class="flex-spinner">
        <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
      </div> 
    </div>
  </div>
</template>

<script>

import Item from "@/models/Solarspot";

export default {
  mounted () {
    this.$auth.check()
    .then(user => { })
    .catch(err => {
      alert(err)
    })

  },
  firebase () {
    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: () => {
          this.ready = true
        }
      }
    };
  },
  data () {
    return {
      token: "",
      Item: new Item(this.$myDatabase.child('Solarspot')).init(),
      ready: false,
      items: ['Osoba prywatna', 'Firma', 'Gospodarstwo rolne'],
      yesno: ['Tak', 'Nie'],
      rodzajdachu: ['Dach płaski', 'Dach jednospadowy', 'Dach dwuspadowy', 'Dach czterospadowy'],
      wymiarybyly: ['Zmierzone', 'Oszacowane'],
      istniejaca: ['1 Fazowa', '3 Fazowa'],
      odgromowa: ['Istnieje', 'Nie istnieje'],
      izolacja: ['Izolacja wierzchna', 'Izolacja spodnia', 'Brak izolacji'],
      materialkrokwi: ['Drewno', 'Stal', 'eton'],
      typdachu: ['Dach krokwiowy', 'Dach płatowy', 'Dach płaski'],
      dostawca: ['PGE', 'Tauron', 'Enea', 'Energa', 'Innogy'],
      projekt: false,
      osd: false,
      realizacja: false
    
    }
  },
  methods: {
    addItem () {
      this.$firebaseRefs.data.onDisconnect().cancel()
      this.Item.push().catch(err => {
          if (err) {  
      alert('Wystąpił błąd spróbuj później lub skontaktuj się z administratorem'+ '\n' + err);
              }     
    })
      this.Item.rodzajKlienta = ""
      this.Item.nazwa = ""
      this.Item.ulica = ""
      this.Item.miasto = ""
      this.Item.gmina = ""
      this.Item.kod = ""
      this.Item.telefon = ""
      this.Item.email = ""
      this.Item.moc = ""
      this.Item.projektDachu = ""
      this.Item.rodzajDachu = ""
      this.Item.wymiaryByly = ""
      this.Item.dlugosc  = ""
      this.Item.szerokosc = ""
      this.Item.dlugoscDachu = ""
      this.Item.kat = ""
      this.Item.istniejaca = ""
      this.Item.przekrojPrzewodu = ""
      this.Item.zabezpieczenie = ""
      this.Item.odgromowa = ""
      this.Item.izolacja = ""
      this.Item.gruboscIzlolacji = ""
      this.Item.materialIzlolacji = ""
      this.Item.typDachu = ""  
      this.Item.materialKrokwi = ""
      this.Item.odlegloscKrokwi = ""
      this.Item.gruboscKrokwi = ""
      this.Item.gruboscKrokwi = ""
      this.Item.dostawca = ""
      this.Item.nabywca = "" 
      this.Item.wartoscZabezpieczenia = ""  
      this.Item.ppe = ""
      this.Item.nrLicznika = "" 
      this.Item.mocPrzylaczeniowa = "" 
      this.Item.mocUmowna = ""   
    },
    deleteItem (key) {
      this.Item.remove(key);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Solarspot.vue?0a7f3c54